/**
 * `StockBatchController`'s HTTP surface (Stage 14, Phase 2, Step 2b —
 * read-only originally; Enterprise Pharmacy Architecture Revision 2
 * Phase 2 — Batch Lifecycle — added the quality/compliance transitions
 * below).
 */
import { httpClient, unwrap, API_ENDPOINTS } from '@core/api';
import type { ApiSuccessResponse, PaginatedResult } from '@app-types/api.types';
import { getPaginatedList } from '@features/administration/services/_pagination';
import type { StockBatchDto } from '@nexao/contracts';

const BASE = API_ENDPOINTS.procurement.stockBatches;

export async function listStockBatches(page = 1, limit = 25): Promise<PaginatedResult<StockBatchDto>> {
  return getPaginatedList<StockBatchDto>(BASE, { params: { page, limit } });
}

export async function listExpiringStockBatches(withinDays = 30): Promise<StockBatchDto[]> {
  return unwrap(httpClient.get<ApiSuccessResponse<StockBatchDto[]>>(`${BASE}/expiring`, { params: { withinDays } }));
}

export interface StockBatchLifecycleActionInput {
  reason?: string;
}

function lifecycleAction(action: string) {
  return (id: string, input: StockBatchLifecycleActionInput = {}): Promise<StockBatchDto> =>
    unwrap(httpClient.post<ApiSuccessResponse<StockBatchDto>>(`${BASE}/${id}/${action}`, input));
}

export const quarantineStockBatch = lifecycleAction('quarantine');
export const flagStockBatchQuality = lifecycleAction('flag-quality');
export const blockStockBatch = lifecycleAction('block');
export const recallStockBatch = lifecycleAction('recall');
export const releaseStockBatch = lifecycleAction('release');
export const confirmStockBatchAvailable = lifecycleAction('confirm-available');
export const disposeStockBatch = lifecycleAction('dispose');
